import { render, staticRenderFns } from "./EditHotel.vue?vue&type=template&id=53228d78&scoped=true&"
import script from "./EditHotel.vue?vue&type=script&lang=js&"
export * from "./EditHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53228d78",
  null
  
)

export default component.exports